import React, { useState, useEffect } from 'react';
import api from '../api/client';
import Pagination from './TablePagination';

const FlexibleSecondaryTable = ({
    parentRowId,
    endpoint,
    columns,
    keyFieldsConfig,
    enableEdit = true,
    enableHistory = true,
    enableDelete = true
}) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(50); 
    const [totalItems, setTotalItems] = useState(0);

    const formatDateTime = (date, type = 'date') => {
        if (!date) return ''; // Проверяем, что дата передана

        // Преобразуем строку в объект Date (ISO-строки с "T" не трогаем, иначе ломается парсинг)
        let parsedDate = new Date(date.includes('T') ? date : date.replace(/-/g, '/'));

        if (isNaN(parsedDate.getTime())) return ''; // Проверяем, корректна ли дата

        // Отнимаем 5 часов вручную
        parsedDate.setHours(parsedDate.getHours() - 5);
    
        if (type === 'datetime') {
            return parsedDate.toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true // 12-часовой формат AM/PM
            });
        }
    
        return parsedDate.toLocaleDateString('en-US');
    };
    
    
    const fetchData = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await api.get(endpoint, {
                params: { page, limit }
            });
            const result = response.data;

            let formattedData = [];
            if (result && Array.isArray(result.data)) {
                formattedData = result.data;
                setTotalItems(result.totalItems || result.total || 0);
            } else if (Array.isArray(result)) {
                formattedData = result;
                setTotalItems(result.length);
            } else {
                console.error('Unexpected API response format:', result);
                setError('Unexpected response format');
                setData([]);
                return;
            }

            formattedData = formattedData.map(item => {
                const formattedItem = { ...item };
                columns.forEach(col => {
                    if (col.type === 'date') {
                        formattedItem[col.key] = formatDateTime(item[col.key], 'date');
                    } else if (col.type === 'datetime') {
                        formattedItem[col.key] = formatDateTime(item[col.key], 'datetime');
                    }
                });
                return formattedItem;
            });

            setData(formattedData);
        } catch (err) {
            console.error('Error fetching data:', err);
            setError('Failed to load data');
            setData([]);
        } finally {
            setLoading(false);
        }
    };
    

    useEffect(() => {
        fetchData();
    }, [endpoint, page, limit]);

    if (loading) return <div>Loading...</div>;
    if (error) return <div className="error-message">Error: {error}</div>;
    if (!Array.isArray(data)) return <div>Error: Data is not an array</div>;
    if (data.length === 0) return <div>No data available</div>;
    const totalPages = Math.ceil(totalItems / limit);

    return (
        <div className="secondary-table">
            <table className="table">
                <thead>
                    <tr>
                        {columns.map(col => <th key={col.key}>{col.label}</th>)}
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) => (
                        <tr key={index}>
                            {columns.map(col => <td key={col.key}>{row[col.key] ?? '-'}</td>)}
                            <td className="table__actions">
                                {/* {enableHistory && (
                                    <i className="fa fa-eye" onClick={() => console.log('View details', row)}></i>
                                )} */}
                                {enableEdit && (
                                    <i className="fa fa-edit" onClick={() => console.log('Edit', row)}></i>
                                )}
                                {enableDelete && (
                                    <i className="fa fa-trash" onClick={() => console.log('Delete', row)}></i>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <Pagination
                page={page}
                totalPages={totalPages}
                limit={limit}
                setPage={setPage}
                setLimit={setLimit}
            />
        </div>
    );
};

export default FlexibleSecondaryTable;
